<template>
    <div class="block-editor go-to-step">
        <div class="wrapper">
            <div class="title">{{ $t('auto.gotoStepSelectTheBlockToGoTo') }}</div>
            <BlockPicker :flatted-diagram="flattedDiagram" v-model="payload.blockId" :isGotoStep="isGotoStep" />
        </div>
    </div>
</template>

<script>
import BlockPicker from "../pickers/BlockPicker";

export default {
    name: "GotoStep",
    components: { BlockPicker },
    props: ["value", "flattedDiagram", "isGotoStep"],
    data() {
        return {
            payload: this.value,
            query: "",
        };
    },
    watch: {
        payload: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
    computed: {},
};
</script>
<style lang="scss">
.block-editor.go-to-step {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .wrapper {
        padding: 10px;

        .title {
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .ant-select {
            width: 100%;
        }
    }
}
</style>
